import { render, staticRenderFns } from "./EdiItems.vue?vue&type=template&id=d67fa348"
import script from "./EdiItems.vue?vue&type=script&lang=js"
export * from "./EdiItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports